import React, { useEffect, useState, useRef } from "react";
import "./ClientsPage.css";
import OuraNav from "../components/OuraNav";
import fetchBase from "../utils/fetchBase";
import AddClient from "./AddClient";

const formatPhone = (phone) => {
    if (!phone) return null;
    const digits = phone.replace(/\D/g, "");
    if (digits.length !== 10) return phone;
    return `(${digits.slice(0, 3)}) ${digits.slice(3, 6)}-${digits.slice(6)}`;
};

const ClientsPage = () => {
    const [clients, setClients] = useState([]);
    const [clientStatuses, setClientStatuses] = useState({});
    const [selectedClients, setSelectedClients] = useState([]);
    const [searchTerm, setSearchTerm] = useState("");
    const [editingClientId, setEditingClientId] = useState(null);
    const tableRef = useRef(null);
    const [editingAddressClient, setEditingAddressClient] = useState(null);
    const [showAddClientModal, setShowAddClientModal] = useState(false);

    useEffect(() => {
        const fetchClients = async () => {
            try {
                const response = await fetch(`${fetchBase}/api/client/by-admin`, {
                    headers: {
                        Authorization: "Bearer " + localStorage.getItem("jwt_token"),
                    },
                });
                if (response.ok) {
                    const data = await response.json();
                    setClients(data);
                } else {
                    console.error("❌ Failed to fetch clients");
                }
            } catch (err) {
                console.error("❌ Error fetching clients:", err);
            }
        };

        const fetchStatuses = async () => {
            try {
                const response = await fetch(`${fetchBase}/api/schedule/client-status`, {
                    headers: {
                        Authorization: "Bearer " + localStorage.getItem("jwt_token"),
                    },
                });
                if (response.ok) {
                    const data = await response.json();
                    const map = {};
                    data.forEach(item => {
                        map[item.clientId] = item.status;
                    });
                    console.log("STATUS MAP:", map);
                    setClientStatuses(map);
                } else {
                    console.error("❌ Failed to fetch client statuses");
                }
            } catch (err) {
                console.error("❌ Error fetching client statuses:", err);
            }
        };

        fetchClients();
        fetchStatuses();
    }, []);

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (tableRef.current && !tableRef.current.contains(event.target)) {
                setEditingClientId(null);
            }
        };
        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);

    const handleDeleteClient = async (clientId) => {
        const confirmDelete = window.confirm("Are you sure you want to delete this client?");
        if (!confirmDelete) return;
        try {
            const response = await fetch(`${fetchBase}/api/client/delete/${clientId}`, {
                method: "DELETE",
                headers: {
                    Authorization: "Bearer " + localStorage.getItem("jwt_token"),
                },
            });
            if (response.ok) {
                setClients(prev => prev.filter(c => c.id !== clientId));
                setSelectedClients(prev => prev.filter(id => id !== clientId));
            } else {
                console.error("❌ Failed to delete client");
            }
        } catch (err) {
            console.error("❌ Error deleting client:", err);
        }
    };

    const handleUpdateClient = async (client) => {
            try {
                console.log("💾 Updating client:", JSON.stringify(client));
                const response = await fetch(`${fetchBase}/api/client/update/${client.id}`, {
                    method: "PUT",
                    headers: {
                        "Content-Type": "application/json",
                        Authorization: "Bearer " + localStorage.getItem("jwt_token"),
                    },
                    body: JSON.stringify(client),
                });
                const text = await response.text();
                console.log("💾 Update response:", response.status, text);
                if (!response.ok) {
                    console.error("❌ Failed to update client");
                }
            } catch (err) {
                console.error("❌ Error updating client:", err);
            }
        };

    return (
        <>
            <OuraNav
                links={[
                    { label: "Dashboard", href: "/admin-dashboard" },
                    { label: "Activity", href: "/activity" },
                    { label: "Clients", href: "/admin/clients" },
                    { label: "Employees", href: "/employees" },
                    { label: "Calendar", href: "/Scheduler" }
                ]}
            />

            <div className="clients-wrapper">
                <div className="clients-header">
                    <h1>Clients</h1>
                    <div className="clients-actions">
                        <button
                            className="add-client-btn"
                            onClick={() => setShowAddClientModal(true)}
                        >
                            + Add Client
                        </button>
                        <input
                            type="text"
                            placeholder="Search clients..."
                            className="client-search"
                            value={searchTerm}
                            onChange={(e) => setSearchTerm(e.target.value)}
                        />
                    </div>
                </div>

                        <div className="clients-table" ref={tableRef}>
                        <div className="clients-table-header">
                        <input
                            type="checkbox"
                            className="select-all-checkbox"
                            checked={clients.length > 0 && selectedClients.length === clients.length}
                            onChange={() => {
                                if (selectedClients.length === clients.length) {
                                    setSelectedClients([]);
                                } else {
                                    setSelectedClients(clients.map(c => c.id));
                                }
                            }}
                        />
                        <span>Client</span>
                        <span>Phone</span>
                        <span>Address</span>
                        <span>Type</span>
                        <span>SSN Last 4</span>
                        <span>Hours /wk</span>
                        <span>DOB</span>
                        <span>Schedule</span>
                        <span className="actions-column"></span>
                    </div>

                    {clients
                        .filter((client) =>
                            `${client.firstName} ${client.lastName}`
                                .toLowerCase()
                                .includes(searchTerm.toLowerCase())
                        )
                        .slice()
                        .sort((a, b) => {
                            const aScheduled = clientStatuses[a.id] === "Scheduled" ? 0 : 1;
                            const bScheduled = clientStatuses[b.id] === "Scheduled" ? 0 : 1;
                            return aScheduled - bScheduled;
                        })
                        .map((client) => (
                            <div
                                key={client.id}
                                className="clients-row"
                                onClick={(e) => {
                                    if (e.target.tagName === "INPUT" || e.target.tagName === "SELECT") return;
                                    setEditingClientId(null);
                                }}
                            >
                                <input
                                    type="checkbox"
                                    className="row-checkbox"
                                    checked={selectedClients.includes(client.id)}
                                    onChange={() => {
                                        if (selectedClients.includes(client.id)) {
                                            setSelectedClients(selectedClients.filter(id => id !== client.id));
                                        } else {
                                            setSelectedClients([...selectedClients, client.id]);
                                        }
                                    }}
                                />

                                {/* Client Name */}
                                <div className="client-name">
                                    <div className="client-avatar" style={{ backgroundColor: client.color }} />
                                        {Number(editingClientId) === Number(client.id) ? (
                                            <input
                                                type="text"
                                                value={(client.firstName || "") + (client.lastName ? " " + client.lastName : "")}
                                                autoFocus
                                                onChange={(e) => {
                                                    const parts = e.target.value.trim().split(" ");
                                                    const updated = clients.map(c =>
                                                        c.id === client.id
                                                            ? { ...c, firstName: parts[0] || "", lastName: parts.slice(1).join(" ") || "" }
                                                            : c
                                                    );
                                                    setClients(updated);
                                                }}
                                                onBlur={(e) => {
                                                    const parts = e.target.value.trim().split(" ");
                                                    const updatedClient = {
                                                        ...clients.find(c => c.id === client.id),
                                                        firstName: parts[0] || "",
                                                        lastName: parts.slice(1).join(" ") || ""
                                                    };
                                                    handleUpdateClient(updatedClient);
                                                }}
                                            />
                                        ) : (
                                            <span>{client.firstName} {client.lastName}</span>
                                        )}
                                </div>

                                {/* Phone */}
                                {Number(editingClientId) === Number(client.id) ? (
                                    <input
                                        type="text"
                                        value={client.phone || ""}
                                        onChange={(e) => {
                                            const updated = clients.map(c =>
                                                c.id === client.id ? { ...c, phone: e.target.value } : c
                                            );
                                            setClients(updated);
                                        }}
                                        onBlur={(e) => {
                                            const updatedClient = { ...clients.find(c => c.id === client.id), phone: e.target.value };
                                            handleUpdateClient(updatedClient);
                                        }}
                                    />
                                ) : (
                                    <span>{formatPhone(client.phone) || "-"}</span>
                                )}

                                {/* Address */}
                                {Number(editingClientId) === Number(client.id) ? (
                                    <input
                                        type="text"
                                        value={client.address || ""}
                                        onChange={(e) => {
                                            const updated = clients.map(c =>
                                                c.id === client.id
                                                    ? { ...c, address: e.target.value }
                                                    : c
                                            );
                                            setClients(updated);
                                        }}
                                        onBlur={(e) => {
                                            const updatedClient = { ...clients.find(c => c.id === client.id), address: e.target.value };
                                            handleUpdateClient(updatedClient);
                                        }}
                                    />
                                ) : (
                                    <span>{client.address || "-"}</span>
                                )}

                                {/* Type */}
                                {Number(editingClientId) === Number(client.id) ? (
                                    <select
                                        value={client.clientType || "VA"}
                                        onChange={(e) => {
                                            const updated = clients.map(c =>
                                                c.id === client.id ? { ...c, clientType: e.target.value } : c
                                            );
                                            setClients(updated);
                                        }}
                                        onBlur={(e) => {
                                            const updatedClient = { ...clients.find(c => c.id === client.id), clientType: e.target.value };
                                            handleUpdateClient(updatedClient);
                                        }}
                                    >
                                        <option value="VA">VA</option>
                                        <option value="STATE">State</option>
                                    </select>
                                ) : (
                                    <span>{client.clientType || "VA"}</span>
                                )}

                                    {/* SSN Last 4 */}
                                    {Number(editingClientId) === Number(client.id) ? (
                                        <input
                                            type="text"
                                            maxLength={4}
                                            value={client.ssnLastFour || ""}
                                            onChange={(e) => {
                                                const updated = clients.map(c =>
                                                    c.id === client.id ? { ...c, ssnLastFour: e.target.value } : c
                                                );
                                                setClients(updated);
                                            }}
                                            onBlur={(e) => {
                                                const liveValue = e.target.value;
                                                const updatedClient = { ...clients.find(c => c.id === client.id), ssnLastFour: liveValue };
                                                handleUpdateClient(updatedClient);
                                            }}
                                        />
                                    ) : (
                                        <span>{client.ssnLastFour || "-"}</span>
                                    )}

                                {/* Hours */}
                                {Number(editingClientId) === Number(client.id) && client.clientType === "VA" ? (
                                    <input
                                        type="number"
                                        value={client.assignedHours || ""}
                                        placeholder="Assigned hrs"
                                        onChange={(e) => {
                                            const value = parseFloat(e.target.value) || null;
                                            const updated = clients.map(c =>
                                                c.id === client.id ? { ...c, assignedHours: value } : c
                                            );
                                            setClients(updated);
                                            const updatedClient = { ...clients.find(c => c.id === client.id), assignedHours: value };
                                            handleUpdateClient(updatedClient);
                                        }}
                                        onBlur={(e) => {
                                            const value = parseFloat(e.target.value) || null;
                                            const updatedClient = { ...clients.find(c => c.id === client.id), assignedHours: value };
                                            handleUpdateClient(updatedClient);
                                        }}
                                    />
                                ) : (
                                    <span>{client.clientType === "VA" ? (client.assignedHours || "-") : "-"}</span>
                                )}





                                    {/* DOB */}
                                    {Number(editingClientId) === Number(client.id) ? (
                                        <input
                                            type="date"
                                            value={client.dateOfBirth || ""}
                                            onChange={(e) => {
                                                const updated = clients.map(c =>
                                                    c.id === client.id ? { ...c, dateOfBirth: e.target.value } : c
                                                );
                                                setClients(updated);
                                                const updatedClient = { ...clients.find(c => c.id === client.id), dateOfBirth: e.target.value };
                                                handleUpdateClient(updatedClient);
                                            }}
                                        />
                                    ) : (
                                        <span>{client.dateOfBirth || "-"}</span>
                                    )}

                                    {/* Schedule Status */}
                                <span
                                    className={`status-badge ${
                                        clientStatuses[client.id]?.toLowerCase().replace(" ", "") || "unassigned"
                                    }`}
                                >
                                    {clientStatuses[client.id] || "Unassigned"}
                                </span>

                                <div className="row-actions">
                                    <span
                                        className="action-icon"
                                        onClick={(e) => {
                                            e.stopPropagation();
                                            setEditingClientId(Number(client.id));
                                        }}
                                    >
                                        ✏️
                                    </span>
                                    <span
                                        className="action-icon"
                                        onClick={() => handleDeleteClient(client.id)}
                                    >
                                        🗑️
                                    </span>
                                    <span className="action-icon">📅</span>
                                </div>
                                </div>
                                ))}
                        </div>
                    </div>

            {showAddClientModal && (
                <div className="modal-overlay">
                    <div className="modal-box">
                        <button
                            className="modal-close"
                            onClick={() => setShowAddClientModal(false)}
                        >
                            ✕
                        </button>
                        <AddClient
                            onSuccess={() => {
                                setShowAddClientModal(false);
                                window.location.reload();
                            }}
                        />
                    </div>
                </div>
            )}
        </>
    );
};

export default ClientsPage;